import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import { Card, Col, Dropdown, Image, Row } from 'react-bootstrap';
import DiscreteReferenceChecks from './candidate-sub-content-pane/discreteReferenceChecks.js';
import {
  faBagShopping,
  faBriefcase,
  faBuilding,
  faCalendarAlt,
  faCar,
  faChevronDown, faChevronUp,
  faDownload,
  faMapMarkerAlt,
  faPen,
  faPlayCircle,
  faIndustry,
  faPhone
} from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { useEffect, useState } from 'react';
import CandidateInfoNavBar from './candidate-info-nav/candidateInfoNavBar';
import CandidateNavContentPane from './candidate-sub-content-pane/candidateNavContentPane';
import ProfessionalMembershipContent from './candidate-sub-content-pane/professionalMembershipContent.js';
import { CandidateService, decodeJWT } from '../../../services/candidateService.js';
import { ClientService } from '../../../services/clientService.js';
import SigniteButton from '../../ui-elements/signite-button/signiteButton.js';
import { PopupContainer, AICallPopup, CallStatusModal, CallHistoryModal } from './popup-container/index.js';
import axios from 'axios';
import { serverConfig } from '../../../services/server-config.js';
import default_profile_image from '../../content-panes/admin-candidate/candiate-info-nav/img/avatar.png';
import { BlandService } from '../../../services/blandService.js';
import { BolnaService } from '../../../services/bolnaService.js';
import CallLogPanel from './callLogPanelClient.js';
import Loader from 'react-spinner-loader';
import { ShortlistDetailsSection } from './shortlistDetailsSection.js';
import { ShortlistDetailsPopup } from './shortlistDetailsPopup.js';

export const CVLeftContainer = ({ candidateData, candidateStatus, refreshCandidate, refreshShortlistDetails, shortlistDetails, triggerScoreRefresh }) => {
  const decoded = decodeJWT(window.localStorage.getItem('authToken'));
  const clientId = _.get(decoded, 'clientId', '');
  const candidateId = _.get(candidateData, 'candidateId', '');
  const [activePopup, setActivePopup] = useState(null);
  const [newFolderName, setNewFolderName] = useState('');
  const [shortlistedCandidates, setShortlistedCandidates] = useState([]);
  const [isRejectionPopupVisible, setRejectionPopupVisible] = useState(false);
  const [selectedCandidateId, setSelectedCandidateId] = useState(null);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [imageUrl, setImageUrl] = useState(default_profile_image);
  const [loading, setLoading] = useState(false);
  const [showShortlistPopup, setShowShortlistPopup] = useState(false);
  const [showShortlistActionPopup, setShowShortlistActionPopup] = useState(false);

  const jobTypes = _.get(candidateData, 'candidate.valueAdds.jobTypes', []);

  const [callData, setCallData] = useState({});
  const [isCallPanelOpen, setCallPanelOpen] = useState(false);
  const [callLoader, setCallLoader] = useState(false);
  const [isAICallPopupVisible, setAICallPopupVisible] = useState(false);

  const [currentExecutionId, setCurrentExecutionId] = useState(null);
  const [isCallStatusModalVisible, setCallStatusModalVisible] = useState(false);
  const [callStatusData, setCallStatusData] = useState(null);
  const [isCallStatusLoading, setCallStatusLoading] = useState(false);

  const [isCallHistoryModalVisible, setCallHistoryModalVisible] = useState(false);
  const [callHistoryData, setCallHistoryData] = useState([]);
  const [isCallHistoryLoading, setCallHistoryLoading] = useState(false);

  const [callStatusSource, setCallStatusSource] = useState(null);
  const [callHistoryScrollTop, setCallHistoryScrollTop] = useState(0);

  // Handler for when AI call is initiated successfully
  const handleAICallInitiated = (callResponse) => {
    console.log('AI Call initiated:', callResponse);
    if (callResponse.executionId) {
      setCurrentExecutionId(callResponse.executionId);
      setCallStatusSource('direct');
      setErrorMessage('');
      fetchCallStatus(callResponse.executionId);
      setCallStatusModalVisible(true);
    }
  };
  const handleCallStatusClose = () => {
    setCallStatusModalVisible(false);

    if (callStatusSource === 'history') {
      setCallHistoryModalVisible(true);
    }

    setCallStatusSource(null);
  };

  // Fetch call status by execution ID
  const fetchCallStatus = async (executionId) => {
    try {
      setCallStatusLoading(true);
      const response = await BolnaService.getCallStatus(executionId);
      const callData = response.data;

      setCallStatusData(callData);

      if (callData?.geminiScore != null) {
        triggerScoreRefresh();
      }
    } catch (err) {
      console.error('Failed to fetch call status:', err);
      setErrorMessage('Failed to fetch call status. Please try again.');
    } finally {
      setCallStatusLoading(false);
    }
  };

  // Refresh call status - calls the backend to fetch latest from Bolna
  const handleRefreshCallStatus = async () => {
    if (currentExecutionId) {
      try {
        setCallStatusLoading(true);
        const response = await BolnaService.refreshCallStatus(currentExecutionId);
        const callData = response.data;

        setCallStatusData(callData);

        if (callData?.geminiScore != null) {
          triggerScoreRefresh();
        }

      } catch (err) {
        console.error('Failed to refresh call status:', err);
        setErrorMessage('Failed to refresh call status. Please try again.');
      } finally {
        setCallStatusLoading(false);
      }
    }
  };

  // Open status modal to view last call status
  const handleViewCallStatus = () => {
    if (currentExecutionId) {
      fetchCallStatus(currentExecutionId);
      setCallStatusModalVisible(true);
    } else {
      setErrorMessage('No call has been initiated yet. Please initiate a call first.');
    }
  };

  // Fetch call history for the candidate
  const fetchCallHistory = async () => {
    if (!candidateId) return;
    try {
      setCallHistoryLoading(true);
      const response = await BolnaService.getCalls(candidateId);
      setCallHistoryData(response.data?.content || []);
    } catch (err) {
      console.error('Failed to fetch call history:', err);
    } finally {
      setCallHistoryLoading(false);
    }
  };

  // Open call history modal
  const handleViewCallHistory = () => {
    fetchCallHistory();
    setCallHistoryModalVisible(true);
  };

  // View details of a specific call from history
  const handleViewCallDetailsFromHistory = (executionId, scrollTop) => {
    setCallHistoryScrollTop(scrollTop);
    setCurrentExecutionId(executionId);
    setCallStatusSource('history');
    setCallHistoryModalVisible(false);
    fetchCallStatus(executionId);
    setCallStatusModalVisible(true);
  };

  // Refresh a specific call from history
  const handleRefreshCallFromHistory = async (executionId) => {
    try {
      const response = await BolnaService.refreshCallStatus(executionId);
      setCallHistoryData(prevCalls =>
        prevCalls.map(call =>
          call.executionId === executionId ? response.data : call
        )
      );
    } catch (err) {
      console.error('Failed to refresh call:', err);
      setErrorMessage('Failed to refresh call status. Please try again.');
    }
  };

  const handleCreateFolder = async (clientId, folderName) => {

    try {
      await ClientService.createFolder(clientId, folderName);
      setActivePopup('folderSelection');
    } catch (error) {
      setErrorMessage('Failed to create folder. Please try again.');
    }
  };

  const handleProfileSaving = async (candidateId, clientId, note) => {
    try {
      await ClientService.shortlistCandidate({
        candidateId,
        folderId: selectedFolder.folderId,
        shortlistStatus: 'SHORTLISTED',
        noteRequest: { note: note ?? '' }
      });

      setActivePopup('shortlistSuccess');
      refreshShortlistDetails();
    } catch (err) {
      const errorMessage =
        err?.response?.status === 409
          ? 'Candidate already shortlisted in this folder. Choose another folder.'
          : 'Failed to shortlist candidate. Please try again.';

      setErrorMessage(errorMessage);
    }
  };


  const openNewFolderPopup = () => {
    setActivePopup('newFolder');
    setRejectionPopupVisible(false);
  };

  const showShortlistingPopup = () => {
    setActivePopup('shortlisting');
  };

  const showRejectionPopup = () => {
    setSelectedCandidateId(candidateId);
    setSelectedClientId(clientId);
    setRejectionPopupVisible(true);
  };

  const confirmRejection = () => {
    setStatus('REJECTED');
    setRejectionPopupVisible(false);
  };

  const handleDropdownClick = (e) => {
    e.preventDefault();
    setSelectedCandidateId(_.get(candidateData, 'candidateId'));
    setSelectedClientId(clientId);
    setShortlistedCandidates([]);
    showShortlistingPopup();
  };

  const downloadFile = (resumePath, fileName) => {
    CandidateService.downloadResume(encodeURI(resumePath))
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => console.error(err));
  };

  const [isCollapsed, setIsCollapsed] = useState(true);
  const [childCandidateNavigation, setChildCandidateNavigation] = useState('experience');

  useEffect(() => {
    const collapsibleContent = document.querySelector('.collapsible-content');
    if (!collapsibleContent) return;
    const lineHeight = parseInt(window.getComputedStyle(collapsibleContent).lineHeight || 0);
    const maxLines = 5;
    const maxHeight = lineHeight * maxLines;

    if (collapsibleContent.clientHeight > maxHeight) {
      setIsCollapsed(true);
    }
  }, []);


  const toggleContent = () => {
    setIsCollapsed(!isCollapsed);
  };


  const handleErrorMessageClose = () => {
    setErrorMessage('');
  };

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const displayPicPath = candidateData?.candidate?.personalDetails?.displayPic?.[0]?.path || null;

        if (!displayPicPath) {
          setImageUrl(default_profile_image);
          return;
        }

        const response = await axios.get(
          `https://${serverConfig.serverBaseAddress}/signite/file/download?path=${displayPicPath}`,
          {
            headers: CandidateService.getAuthHeader(),
            responseType: 'blob',
          }
        );

        const imageBlob = new Blob([response.data], { type: 'image/jpeg' });
        const url = URL.createObjectURL(imageBlob);
        setImageUrl(url);
      } catch (error) {
        console.error('Error fetching image:', error);
        setImageUrl(default_profile_image);
      }
    };

    if (candidateData) {
      fetchImage();
    }

    return () => {
      if (imageUrl && imageUrl.startsWith('blob:')) {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, [candidateData]);


  const statusStyles = {
    HIRED: { backgroundColor: '#DDFFE9', color: '#3BB765' },
    REJECTED: { backgroundColor: '#FFEBE5', color: '#F35824' },
    SHORTLISTED: { backgroundColor: '#FBF0D3', color: '#FFB700' },
    ON_HOLD: { backgroundColor: '#E4E8FF', color: '#172155' },
    INTERVIEWED: { backgroundColor: '#F0E1FE', color: '#9364ED' },
  };

  const activeShortlistStatus = React.useMemo(() => {
    if (!Array.isArray(shortlistDetails) || shortlistDetails.length === 0) {
      return null;
    }

    const latestFolder = [...shortlistDetails]
      .sort((a, b) => (b.shortlistedDate || 0) - (a.shortlistedDate || 0))[0];

    const activeNode = _.get(
      latestFolder,
      'shortlistHistory.shortlistHistoryNodes',
      []
    ).find((n) => n.active);

    return activeNode?.shortlistStatus || null;
  }, [shortlistDetails]);

  const hasShortlistActionDone = React.useMemo(() => {
    return Array.isArray(shortlistDetails) && shortlistDetails.length > 0;
  }, [shortlistDetails]);

  React.useEffect(() => {
    if (!candidateId) return;

    fetchCallHistory();
  }, [candidateId]);

  // const hasAIInterviewDone = React.useMemo(() => {
  //   return Array.isArray(callHistoryData) && callHistoryData.length > 0;
  // }, [callHistoryData]);

  // const hasCallDetails = React.useMemo(() => {
  //   return Array.isArray(callHistoryData) && callHistoryData.length > 0;
  // }, [callHistoryData]);

  const hasAnyCallStarted = React.useMemo(() => {
    return !!currentExecutionId || (callHistoryData && callHistoryData.length > 0);
  }, [currentExecutionId, callHistoryData]);


  return (
    <Col className="pb-3">
      <Card>
        <Card.Body className="candidateInformation">
          {errorMessage && (
            <div className="custom-alert-overlay">
              <div className="custom-alert-box">
                <div className="custom-alert-content">
                  <p>{errorMessage}</p>
                  <button
                    className="candidate-alert-button"
                    onClick={() => setErrorMessage('')}

                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          )}
          <Row className="d-none d-md-flex">
            <Col md={2} className="d-flex justify-content-center">
              <div className="profile-image-with-cv text-center">
                {/* Profile Image */}
                <div className="rounded-circle overflow-hidden position-relative profile-pic-container mt-2">
                  <Image
                    src={imageUrl || default_profile_image}
                    width={120}
                    height={120}
                    alt="Profile Image"
                    aspectRatio="16x9"
                  />
                </div>

                {/* Download CV – BELOW IMAGE */}
                <div className="download-resume-section">
                  <a
                    href="#"
                    className="candidateCVDownload"
                    onClick={(e) => {
                      e.preventDefault();

                      const resumePath = _.get(
                        candidateData,
                        'candidate.personalDetails.resume[0].path',
                        null
                      );
                      const resumeName = _.get(
                        candidateData,
                        'candidate.personalDetails.resume[0].displayFileName',
                        null
                      );

                      if (!resumePath || !resumeName) {
                        setErrorMessage('Resume not available for the candidate');
                      } else {
                        downloadFile(resumePath, resumeName);
                      }
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload} /> Download CV
                  </a>
                </div>
              </div>
            </Col>


            <Col md={6} className="d-flex justify-content-left align-items-center">
              <Row>
                <Col md={12}>
                  <h2 className="candidateTitle">
                    {_.get(candidateData, 'candidate.personalDetails.firstName')}{' '}
                    {_.get(candidateData, 'candidate.personalDetails.lastName')} | {_.get(candidateData, 'candidateId')}
                  </h2>
                </Col>
                <Col md={12}>
                  <h3 className="candidateSubTitle">
                    {_.get(candidateData, 'candidate.workExperience.currentRole.designation')}{' '}
                    <span className="candidateSubTitleStyle2">
                      {_.get(candidateData, 'candidate.workExperience.currentRole.designation') ? ' at ' : ''}
                      {_.get(candidateData, 'candidate.workExperience.currentRole.orgName')},{' '}
                      {_.get(candidateData, 'candidate.workExperience.currentRole.location')}
                    </span>
                  </h3>
                </Col>
                <Col md={12}>
                  <h3 className="candidateSubTitle candidateSubTitleStyle2">
                    {/* Industry */}
                    <FontAwesomeIcon className="preference-icon" icon={faIndustry} />{' '}
                    {_.get(candidateData, 'candidate.workExperience.currentRole.industry')}

                    {_.get(candidateData, 'candidate.workExperience.currentRole.industrySubcategory') && (
                      <>
                        {' - '}
                        {_.get(
                          candidateData,
                          'candidate.workExperience.currentRole.industrySubcategory'
                        )}
                      </>
                    )}

                    {/* Function */}
                    {_.get(candidateData, 'candidate.workExperience.currentRole.function') && (
                      <>
                        {' | '}
                        <FontAwesomeIcon className="preference-icon" icon={faBuilding} />{' '}
                        {_.get(candidateData, 'candidate.workExperience.currentRole.function')}

                        {_.get(
                          candidateData,
                          'candidate.workExperience.currentRole.functionSubcategory'
                        ) && (
                            <>
                              {' - '}
                              {_.get(
                                candidateData,
                                'candidate.workExperience.currentRole.functionSubcategory'
                              )}
                            </>
                          )}
                      </>
                    )}
                  </h3>
                </Col>

              </Row>
            </Col>
            <Col md={4} className="candidate-actions-panel executive-rail">

              {/* PRIMARY EXECUTIVE ACTION */}
              <div className="action-block executive-primary">
                <SigniteButton
                  variant="primary"
                  className={`signite-button executive-action-btn sl-single-line-btn shortlist-status-btn ${hasAnyCallStarted
                    ? 'signite-button-call-success has-status'
                    : 'signite-button-pre-call'
                    }`}
                  onClick={(e) => {
                    e.preventDefault();
                    setAICallPopupVisible(true);
                  }}
                >
                  AI Interview &nbsp; <FontAwesomeIcon icon={faPhone} />
                </SigniteButton>

                <SigniteButton
                  variant="primary"
                  className={`signite-button executive-action-btn ${hasAnyCallStarted
                    ? 'signite-button-call-success'
                    : 'signite-button-pre-call'
                    }`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleViewCallHistory();
                  }}
                >
                  Call Details
                </SigniteButton>


              </div>

              <div className="action-block executive-shortlist">
                <SigniteButton
                  variant="primary"
                  className={`signite-button executive-action-btn ${hasShortlistActionDone ? 'signite-button-soft-orange' : ''
                    }`}
                  onClick={handleDropdownClick}
                >
                  Shortlist
                </SigniteButton>

                <SigniteButton
                  variant="primary"
                  className={`signite-button executive-action-btn ${hasShortlistActionDone ? 'signite-button-soft-orange' : ''
                    }`}
                  onClick={() => setShowShortlistPopup(true)}
                >
                  Status <span className="status-arrow">▾</span>

                  {hasShortlistActionDone && (
                    <span className="shortlist-floating-badge">
                      Click to view shortlist status
                    </span>
                  )}
                </SigniteButton>


              </div>

              <ShortlistDetailsPopup
                open={showShortlistPopup}
                onClose={() => setShowShortlistPopup(false)}
                shortlistDetails={shortlistDetails}
                candidateId={candidateId}
                refreshShortlistDetails={refreshShortlistDetails}
              />

              <PopupContainer
                activePopup={activePopup}
                newFolderName={newFolderName}
                setNewFolderName={setNewFolderName}
                setActivePopup={setActivePopup}
                shortlistedCandidates={shortlistedCandidates}
                setShortlistedCandidates={setShortlistedCandidates}
                handleProfileSaving={handleProfileSaving}
                openNewFolderPopup={openNewFolderPopup}
                handleCreateFolder={handleCreateFolder}
                showShortlistingPopup={showShortlistingPopup}
                isRejectionPopupVisible={isRejectionPopupVisible}
                setRejectionPopupVisible={setRejectionPopupVisible}
                confirmRejection={confirmRejection}
                clientId={clientId}
                candidateId={candidateId}
                selectedCandidateId={selectedCandidateId}
                selectedClientId={selectedClientId}
                selectedFolder={selectedFolder}
                setSelectedFolder={setSelectedFolder}
                handleErrorMessageClose={handleErrorMessageClose}
              />
              <AICallPopup
                isVisible={isAICallPopupVisible}
                onClose={() => setAICallPopupVisible(false)}
                candidateId={candidateId}
                onCall={handleAICallInitiated}
              />
              <CallStatusModal
                isVisible={isCallStatusModalVisible}
                onClose={handleCallStatusClose} callStatus={callStatusData}
                onRefresh={handleRefreshCallStatus}
                isLoading={isCallStatusLoading}
              />
              <CallHistoryModal
                isVisible={isCallHistoryModalVisible}
                onClose={() => setCallHistoryModalVisible(false)}
                calls={callHistoryData}
                onViewCallDetails={handleViewCallDetailsFromHistory}
                onRefreshCall={handleRefreshCallFromHistory}
                isLoading={isCallHistoryLoading}
                initialScrollTop={callHistoryScrollTop}
              />
            </Col>

          </Row>
          <Row className="d-none d-md-flex">
            <Col md={12} className="d-md-flex justify-content-left pt-3">
              <h3 className="candidateSubTitle candidateSubTitleStyle2">
                <FontAwesomeIcon className="preference-icon" icon={faMapMarkerAlt} /> Location Preference: {' '}
                {[
                  _.get(candidateData, 'candidate.valueAdds.locationPref1') && `${_.get(candidateData, 'candidate.valueAdds.locationPref1')}`,
                  _.get(candidateData, 'candidate.valueAdds.locationPref2') && `${_.get(candidateData, 'candidate.valueAdds.locationPref2')}`,
                  _.get(candidateData, 'candidate.valueAdds.locationPref3') && `${_.get(candidateData, 'candidate.valueAdds.locationPref3')}`,
                ]
                  .filter(Boolean)
                  .join(' | ')}
              </h3>
            </Col>
            <Col md={12} className="d-md-flex justify-content-left pt-2">
              <h3 className="candidateSubTitle candidateSubTitleStyle2">
                {' '}
                <FontAwesomeIcon className="preference-icon" icon={faBriefcase}></FontAwesomeIcon> Work Preference :{' '}

                {Array.isArray(jobTypes) && jobTypes.length > 0 ? (
                  jobTypes.map((jobType, index) => (
                    <React.Fragment key={index}>
                      {jobType}
                      {index < jobTypes.length - 1 ? ' | ' : ''}
                    </React.Fragment>
                  ))
                ) : (
                  ''
                )}

              </h3>
            </Col>
            <Col md={12} className="d-md-flex justify-content-left pt-2">
              <h3 className="candidateSubTitle candidateSubTitleStyle2">
                <span className="col-sm-4 d-block d-md-inline">
                  <FontAwesomeIcon className="preference-icon" icon={faCar}></FontAwesomeIcon> Willing To Relocate :{' '}
                  {_.get(candidateData, 'candidate.valueAdds.willingToRelocate')}
                </span>
                <span className="ps-md-2 col-sm-4 d-block d-md-inline">
                  <FontAwesomeIcon className="preference-icon" icon={faBagShopping}></FontAwesomeIcon> Willing To Travel For Work :{' '}
                  {_.get(candidateData, 'candidate.valueAdds.willingToTravelToWork')}
                </span>
                <span className="ps-md-2 col-sm-4 d-block d-md-inline">
                  <FontAwesomeIcon className="preference-icon" icon={faCalendarAlt}></FontAwesomeIcon> Preferred Number of Working Days :{' '}
                  {_.get(candidateData, 'candidate.valueAdds.willingToWorkSixDayWeeks') === 'YES'
                    ? 'Six Days'
                    : 'Five Days'}
                </span>
              </h3>
            </Col>
            <hr></hr>
          </Row>

          {/* Small-Screen Layout */}
          <Row className="d-md-none align-items-center" >
            <Col xs={3} className="d-flex justify-content-center" style={{ paddingLeft: '0', paddingRight: '0' }}>
              <div className="rounded-circle overflow-hidden position-relative profile-pic-container ">
                <Image
                  src={imageUrl || default_profile_image}
                  width={80}
                  height={80}
                  alt="Profile Image"
                  roundedCircle
                />
                {' '}
                {/* <div className="overlay">
                  <FontAwesomeIcon icon={faPen} color="#F35824" />
                </div> */}
              </div>

            </Col>
            <Col xs={9} >
              <h2 className="candidateTitle">
                {_.get(candidateData, 'candidate.personalDetails.firstName')}{' '}
                {_.get(candidateData, 'candidate.personalDetails.lastName')} | {_.get(candidateData, 'candidateId')}
              </h2>
              <h3 className="candidateSubTitle">
                {_.get(candidateData, 'candidate.workExperience.currentRole.designation')}
                <span className="candidateSubTitleStyle2">
                  {_.get(candidateData, 'candidate.workExperience.currentRole.designation') ? ' at ' : ''}
                  {_.get(candidateData, 'candidate.workExperience.currentRole.orgName')},
                  {_.get(candidateData, 'candidate.workExperience.currentRole.location')}
                </span>
              </h3>
            </Col>
            <div className="download-resume-section d-md-none">
              <a
                href="#"
                className="candidateCVDownload"
                onClick={(e) => {
                  e.preventDefault();

                  const resumePath = _.get(candidateData, 'candidate.personalDetails.resume[0].path', null);
                  const resumeName = _.get(candidateData, 'candidate.personalDetails.resume[0].displayFileName', null);

                  if (!resumePath || !resumeName) {
                    setErrorMessage('Resume not available for the candidate');
                  } else {
                    downloadFile(resumePath, resumeName);
                  }
                }}
              >
                <FontAwesomeIcon icon={faDownload} /> Download CV
              </a>
            </div>
            <Col>
              <br />
              <Row>
                <h3 className="candidateSubTitle candidateSubTitleStyle2">
                  <FontAwesomeIcon className="preference-icon" icon={faIndustry} />{' '}
                  {_.get(candidateData, 'candidate.workExperience.currentRole.industry')}

                  {_.get(candidateData, 'candidate.workExperience.currentRole.industrySubcategory') && (
                    <>
                      {' - '}
                      {_.get(
                        candidateData,
                        'candidate.workExperience.currentRole.industrySubcategory'
                      )}
                    </>
                  )}
                </h3>
              </Row>

              <Row>
                <h3 className="candidateSubTitle candidateSubTitleStyle2">
                  {_.get(candidateData, 'candidate.workExperience.currentRole.function') && (
                    <>
                      <FontAwesomeIcon className="preference-icon" icon={faBuilding} />{' '}
                    </>
                  )}

                  {_.get(candidateData, 'candidate.workExperience.currentRole.function')}

                  {_.get(
                    candidateData,
                    'candidate.workExperience.currentRole.functionSubcategory'
                  ) && (
                      <>
                        {' - '}
                        {_.get(
                          candidateData,
                          'candidate.workExperience.currentRole.functionSubcategory'
                        )}
                      </>
                    )}
                </h3>
              </Row>


            </Col>

            <Col md={6} xs={12} className="d-md-flex justify-content-left pt-3">
              <h3 className="candidateSubTitle candidateSubTitleStyle2">
                <FontAwesomeIcon className="preference-icon" icon={faMapMarkerAlt} /> Location Preference: {' '}
                {[
                  _.get(candidateData, 'candidate.valueAdds.locationPref1') && `${_.get(candidateData, 'candidate.valueAdds.locationPref1')}`,
                  _.get(candidateData, 'candidate.valueAdds.locationPref2') && `${_.get(candidateData, 'candidate.valueAdds.locationPref2')}`,
                  _.get(candidateData, 'candidate.valueAdds.locationPref3') && `${_.get(candidateData, 'candidate.valueAdds.locationPref3')}`,
                ]
                  .filter(Boolean)
                  .join(' | ')}
              </h3>

            </Col>
            <Col md={12} xs={12} className="d-md-flex justify-content-left pt-2">
              <h3 className="candidateSubTitle candidateSubTitleStyle2">
                {' '}
                <FontAwesomeIcon className="preference-icon" icon={faBriefcase}></FontAwesomeIcon> Work Preference :{' '}
                {Array.isArray(jobTypes) && jobTypes.length > 0 ? (
                  jobTypes.map((jobType, index) => (
                    <React.Fragment key={index}>
                      {jobType}
                      {index < jobTypes.length - 1 ? ' | ' : ''}
                    </React.Fragment>
                  ))
                ) : (
                  ''
                )}
              </h3>
            </Col>
            <Col md={12} xs={12} className="pt-2">
              <div className="d-flex flex-wrap align-items-start gap-3">
                <div className="d-flex align-items-center">
                  <span className="d-flex align-items-center candidateSubTitle candidateSubTitleStyle2">
                    <FontAwesomeIcon icon={faCar} className="preference-icon me-2" />
                    Willing To Relocate: {_.get(candidateData, 'candidate.valueAdds.willingToRelocate')}
                  </span>
                </div>

                <div className="d-flex align-items-center">
                  <span className="d-flex align-items-center candidateSubTitle candidateSubTitleStyle2">
                    <FontAwesomeIcon icon={faBagShopping} className="preference-icon me-2" />
                    Willing To Travel For Work: {_.get(candidateData, 'candidate.valueAdds.willingToTravelToWork')}
                  </span>
                </div>

                <div className="d-flex align-items-center">
                  <span className="d-flex align-items-center candidateSubTitle candidateSubTitleStyle2">
                    <FontAwesomeIcon icon={faCalendarAlt} className="preference-icon me-2" />
                    Preferred Number of Working Days: {_.get(candidateData, 'candidate.valueAdds.willingToWorkSixDayWeeks') === 'YES' ? 'Six Days' : 'Five Days'}
                  </span>
                </div>
              </div>
            </Col>

            <hr />
            <Col md={4}>
              <div className='smallscreen-metcontents'>

                <Row>


                  <Col xs={12}>
                    <div className="smallscreen-action-stack">
                      <SigniteButton
                        variant="primary"
                        className={`signite-button executive-action-btn sl-single-line-btn shortlist-status-btn ${hasAnyCallStarted
                          ? 'signite-button-call-success has-status'
                          : 'signite-button-pre-call'
                          }`}
                        onClick={(e) => {
                          e.preventDefault();
                          setAICallPopupVisible(true);
                        }}
                      >
                        AI Interview &nbsp; <FontAwesomeIcon icon={faPhone} />
                      </SigniteButton>

                      <SigniteButton
                        variant="primary"
                        className={`signite-button executive-action-btn ${hasAnyCallStarted
                          ? 'signite-button-call-success'
                          : 'signite-button-pre-call'
                          }`}
                        onClick={(e) => {
                          e.preventDefault();
                          handleViewCallHistory();
                        }}
                      >
                        Call Details
                      </SigniteButton>


                      <SigniteButton
                        variant="primary"
                        className={`signite-button executive-action-btn ${hasShortlistActionDone ? 'signite-button-soft-orange' : ''
                          }`}
                        onClick={handleDropdownClick}
                      >
                        Shortlist
                      </SigniteButton>

                      <SigniteButton
                        variant="primary"
                        className={`signite-button executive-action-btn ${hasShortlistActionDone ? 'signite-button-soft-orange' : ''
                          }`}

                        onClick={() => setShowShortlistPopup(true)}
                      >
                        Status <span className="status-arrow">▾</span>

                        {hasShortlistActionDone && (
                          <span className="shortlist-floating-badge">
                            Click to view shortlist status
                          </span>
                        )}
                      </SigniteButton>


                      <Loader show={callLoader} type="body" message="Loading call logs..." />
                      <CallLogPanel
                        data={callData}
                        isCallPanelOpen={isCallPanelOpen}
                        setCallPanelOpen={setCallPanelOpen}
                      />
                    </div>
                  </Col>
                  <PopupContainer
                    activePopup={activePopup}
                    newFolderName={newFolderName}
                    setNewFolderName={setNewFolderName}
                    setActivePopup={setActivePopup}
                    shortlistedCandidates={shortlistedCandidates}
                    setShortlistedCandidates={setShortlistedCandidates}
                    handleProfileSaving={handleProfileSaving}
                    openNewFolderPopup={openNewFolderPopup}
                    handleCreateFolder={handleCreateFolder}
                    showShortlistingPopup={showShortlistingPopup}
                    isRejectionPopupVisible={isRejectionPopupVisible}
                    setRejectionPopupVisible={setRejectionPopupVisible}
                    confirmRejection={confirmRejection}
                    clientId={clientId}
                    candidateId={candidateId}
                    selectedCandidateId={selectedCandidateId}
                    selectedClientId={selectedClientId}
                    selectedFolder={selectedFolder}
                    setSelectedFolder={setSelectedFolder}
                    handleErrorMessageClose={handleErrorMessageClose}
                  />
                  <AICallPopup
                    isVisible={isAICallPopupVisible}
                    onClose={() => setAICallPopupVisible(false)}
                    candidateId={candidateId}
                    onCall={handleAICallInitiated}
                  />
                  <CallStatusModal
                    isVisible={isCallStatusModalVisible}
                    onClose={handleCallStatusClose} callStatus={callStatusData}
                    onRefresh={handleRefreshCallStatus}
                    isLoading={isCallStatusLoading}
                  />
                  <CallHistoryModal
                    isVisible={isCallHistoryModalVisible}
                    onClose={() => setCallHistoryModalVisible(false)}
                    calls={callHistoryData}
                    onViewCallDetails={handleViewCallDetailsFromHistory}
                    onRefreshCall={handleRefreshCallFromHistory}
                    isLoading={isCallHistoryLoading}
                    initialScrollTop={callHistoryScrollTop}
                  />
                </Row>

                <br />
              </div>
            </Col>
            <hr />

          </Row>

          <Row>
            <Col md={12} className="ps-4">
              <div id="collapsibleSection">
                <div className={`collapsible-content ${isCollapsed ? 'collapsed' : ''}`}>
                  <h2 className="candidateDisplaySectionHeadingStyle1">Expertise</h2>
                  <div className="candidateDisplaySectionContentStyle1">
                    {(_.get(candidateData, 'candidate.workExperience.currentRole.topThreeResponsibilities') || '')
                      .split('\n')
                      .filter((line) => line.trim() !== '')
                      .map((text, index) => (
                        <p key={index}>{text}</p>
                      ))}
                  </div>

                  <h2 className="candidateDisplaySectionHeadingStyle1">Achievements</h2>

                  <div className="candidateDisplaySectionContentStyle1">
                    {(_.get(candidateData, 'candidate.workExperience.currentRole.topThreeAchievements') || '')
                      .split('\n')
                      .filter((line) => line.trim() !== '')
                      .map((text, index) => (
                        <p key={index}>{text}</p>
                      ))}
                  </div>

                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="d-flex justify-content-center candidateCVDownload">
              <a id="toggleButton" onClick={toggleContent}>
                {isCollapsed ? 'View More' : 'View Less'}{' '}
                <span>
                  <FontAwesomeIcon icon={isCollapsed ? faChevronDown : faChevronUp} />
                </span>
              </a>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Card className="mt-3 p-0 navCard remove-border-radius">
        <Card.Body className="candidateInformation p-0">
          <CandidateInfoNavBar setChildNavigation={setChildCandidateNavigation} />
        </Card.Body>
      </Card>
      <Card className="mt-3 p-0 navCard">
        <Card.Body className="candidateInformation p-0">
          <CandidateNavContentPane
            currentNavigation={childCandidateNavigation}
            candidateData={_.get(candidateData, 'candidate')}
          />
        </Card.Body>
      </Card>
      <Card className="mt-3 p-0 navCard mb-3">
        <Card.Body className="candidateInformation p-0">
          <DiscreteReferenceChecks
            reference1={_.get(candidateData, 'candidate.valueAdds.reference1')}
            reference2={_.get(candidateData, 'candidate.valueAdds.reference2')}
          ></DiscreteReferenceChecks>
        </Card.Body>
      </Card>
      <ProfessionalMembershipContent
        professionalReferences={_.get(candidateData, 'candidate.valueAdds.professionalReferences', [])}
        professionalMemberships={_.get(candidateData, 'candidate.workExperience.professionalMemberships', [])}
      ></ProfessionalMembershipContent>
    </Col>
  );

};